import { useEffect } from 'react';

import { startSquircleEnhancer } from './squircle-enhancer';

/**
 * Document-level G2 squircle enhancer for Tailwind `rounded-lg`+ / `.card` surfaces.
 * Mount once under the app root. sm/md/full stay G1.
 */
export function SquircleEnhancer() {
    useEffect(() => startSquircleEnhancer(document), []);
    return null;
}
